// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__DSPgj","header_container":"Header_header_container__j0ACC","logo":"Header_logo__ylXGi","info":"Header_info__EK85e","navigation":"Header_navigation__o9f6-"};